import * as React from "react";
import { IPostProps } from "./IPost";
import FollowPost from "../FollowPost/FollowPost";
import ReportFeed from "../ReportFeed/ReportFeed";
import TextEditor from "../TextEditor/TextEditor";
import PinFilledIcon from "@assets/svg/pin-filled.svg";
import { formatDate, isAndroidDevice } from "@features/utils/functions";

import * as style from "./PostStyle.module.scss";
import { Tooltip } from "antd";

export default class Post extends React.Component<IPostProps> {
  renderPitchCommentRow = () => {
    const { repliedPitchName } = this.props;

    if (repliedPitchName) {
      return (
        <React.Fragment>
          <span className={style.postCommentOn}> made comment on </span>
          <a
            href={`/pitches/${repliedPitchName.slug}`}
            title={repliedPitchName.name}
          >
            <strong>{repliedPitchName.name}</strong>
          </a>
        </React.Fragment>
      );
    }
    return;
  };

  render() {
    const {
      avatar,
      created_at,
      name,
      byOwner,
      isComment,
      id,
      current_user_subscription_id,
      subscribed,
      is_html_safe,
      is_deleted,
      message,
      shouldDispalyPin,
      pinned,
    } = this.props;

    return (
      <div>
        <div>
          <div className={style.postInfo}>
            <div
              className={style.postInfoImg}
              style={{ backgroundImage: `url(${avatar})` }}
            />
            <div className={style.postInfoDetails}>
              <h5 className={style.postInfoDetailsName}>
                {name}
                {this.renderPitchCommentRow()}
              </h5>
              <span className={style.postInfoDetailsDate}>
                {formatDate(created_at, true)}
              </span>
            </div>
            <div className={style.postAdditionalInfoContainer}>
              {byOwner && (
                <div className={style.postOwnerLabel}>Company update</div>
              )}
              {shouldDispalyPin && pinned && (
                <Tooltip title="Pin item">
                  <div className={style.postPin}>
                    <PinFilledIcon />
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
          {!is_deleted && (
            <div className={style.postOther}>
              <ReportFeed postId={id} />
              {!isComment && (
                <FollowPost
                  subscription_id={current_user_subscription_id}
                  parentId={id}
                  subscribed={subscribed}
                />
              )}
            </div>
          )}
        </div>
        <div className={style.postContent}>
          {!is_html_safe ? (
            <TextEditor
              read={is_deleted ? `This comment has been removed` : message}
              avatar="test.jpg"
              setButtonStatus={() => {}}
              isDeleted={is_deleted}
              disabledForAndroid={isAndroidDevice()}
            />
          ) : (
            <div
              className={[
                style.postContentHolder,
                is_deleted ? style.postContentDeleted : "",
              ].join(" ")}
              dangerouslySetInnerHTML={{
                __html: is_deleted ? "This comment has been removed" : message,
              }}
            />
          )}
        </div>
      </div>
    );
  }
}
